export default __webpack_public_path__ + "static/media/logo.35638c53.png";